import {
  checkIfOptionalProducts, calculateBeautyPoints, calculateTotalOptionalProductPrices, triggerEvent, findPrice, updatePrice,
} from './functions';

/* global translation subscriptionProductOptions */

/**
 * Size option picker
 */
jQuery(($) => {
  // Size buttons container
  const maksimerSizes = $('.maksimer-size-options');

  // Add to cart ajax functionality.
  function sizesAddToCart(body, btn) {
    const btnAddToCart = $('.single_add_to_cart_button');

    btnAddToCart.off().on('click', function sizeToCart(e) {
      // Check if subscription checkbox is NOT selected.
      if (!($('.subscription-option-faker-checkbox').is(':checked'))) {
        e.preventDefault();

        // Check for selected accessories and get their product IDs.
        const accessoryIds = [];
        $('.entry-summary .optional-products-wrapper input.optional-products-checkbox').each(function sizeAccesory() {
          if ($(this).is(':checked')) {
            const val = $(this).val();
            accessoryIds.push(val);
          }
        });

        // Ajax for adding product to cart and getting back popup html.
        $.post(translation.ajaxurl, {
          action: 'maksimer_woocommerce_single_product_size_add_to_cart',
          productId: $(this).attr('value'),
          productQty: $(this).parent().find('.quantity input.qty').val(),
          productPrice: $(this).parent().find('input[name="gtm4wp_price"]').val(),
          accessoryIds,
          fullSizeProductId: btn.first().attr('data-product-id'),
          sampleProductId: btn.last().attr('data-product-id'),
        }, (response) => {
          // Triggering mini cart refresh.
          triggerEvent(document.body, 'wc_fragment_refresh');

          // Parsing json
          const data = $.parseJSON(response);

          if (data.indexOf('woocommerce-error') > -1) {
            const noticeWrap = body.find('.woocommerce-notices-wrapper');
            noticeWrap.html(data);
            window.scrollTo({
              top: 10,
              left: 0,
              behavior: 'smooth',
            });
          }

          // Check if response is not empty.
          if (typeof data !== 'undefined') {
            // Pre-pending added to cart popup.
            const footer = $('.wp-footer');
            footer.find('#added-to-cart-popup').remove();
            footer.prepend(data);

            // Adding close button and functionality for hiding popup when
            // close and continue shopping buttons are clicked.
            const close = '<div class="close-popup">×</div>';
            const newPopup = footer.find('#added-to-cart-popup');
            newPopup.find('.inner').append(close);
            newPopup.find('.close-popup, .continue-shopping').on('click', (event) => {
              event.preventDefault();
              newPopup.removeClass('open');
            });

            // Removing suggested products from popup and placing
            // the ones that belong to the full size product.
            const fullSizeSuggestedProducts = $('.full-size-suggested-products');
            if (fullSizeSuggestedProducts.length) {
              const clone = fullSizeSuggestedProducts.clone();
              fullSizeSuggestedProducts.remove();
              const suggestedProducts = newPopup.find('.suggested-products');
              if (suggestedProducts.length) {
                suggestedProducts.replaceWith(clone);
              } else {
                newPopup.find('.inner').append(clone);
              }
            }
          }
        });
      }
    });
  }

  if (maksimerSizes.length) {
    const btn = maksimerSizes.find('.maksimer-size-option');
    const body = $('body');

    // If buttons are present in DOM
    if (btn.length) {
      // Disabled the active button from being clickable on init
      body.find('.maksimer-size-option.active').prop('disabled', true);

      // On button click function
      btn.on('click', function sizeBtn(e) {
        e.preventDefault();
        btn.removeClass('active');
        btn.attr('disabled', 'disabled');
        body.addClass('maksimer-size-options-loading');
        $(this).parent().addClass('maksimer-size-options-disabled');
        $(this).addClass('active maksimer-size-option-loading');

        // Remove subscription body class for the reason if user has selected it before switching sizes.
        $(body).removeClass('have-chosen-subscription-option');

        const productId = $(this).attr('data-product-id');

        // Get product details
        $.post(translation.ajaxurl, {
          action: 'maksimer_woocommerce_single_product_size_choice_update', productId,
        }, (response) => {
          const data = $.parseJSON(response);

          // Set product name
          if (typeof data.name !== 'undefined') {
            body.find('.summary .product_title, .sticky-product-inner .product-title, .product-header .product-info-title > h1').html(data.name);
            body.find('.product-header .name-col > h1').html(data.name);
            checkIfOptionalProducts(); // Add an optional products title if needed
          }

          // Set size html
          if (typeof data.size !== 'undefined') {
            const productSize = body.find('.summary .product-size, .product-header .product-size');
            productSize.html(data.size);
          }

          // Set price
          if (typeof data.price !== 'undefined') {
            const pricePlaces = body.find('.summary .price, .sticky-product-inner .price, .product-header .price');
            pricePlaces.html(data.price);

            // Check if any of the accessories are selected, get their calculated price and increase the page price
            const accessoriesPrice = calculateTotalOptionalProductPrices();
            if (accessoriesPrice !== 0) {
              const priceSale = body.find('.summary .price ins > span, .sticky-product-inner .price ins > span, .product-header .price ins > span');
              let price = body.find('.summary .price > span, .sticky-product-inner .price > span, .product-header .price > span');
              if (priceSale.length) {
                price = priceSale;
              }
              const priceValue = price.first().text().replace(/[^0-9]/gi, '');
              const finalPrice = parseInt(priceValue, 10) + parseInt(accessoriesPrice, 10);
              const currency = $('.summary .woocommerce-Price-currencySymbol:first').text();
              price.html(`<span class="woocommerce-Price-currencySymbol">${currency}</span> ${finalPrice}`);
            }
          }

          const firstSlide = document.querySelector('.woocommerce-product-gallery__wrapper > .woocommerce-product-gallery__image');
          const firstIsVideo = firstSlide.classList.contains('woocommerce-product-gallery__video');

          // Set gallery images
          if (typeof data.images !== 'undefined') {
            // Slider images
            const images = body.find('.woocommerce-product-gallery__image a img').first();
            images.attr('src', '').attr('srcset', '').attr('data-large_image', '');
            images.attr('src', data.images[0]);
            images.attr('data-large_image', data.images[0]);

            // Slider navigation thumbs
            let thumbs = body.find('.flex-control-thumbs li img').first();
            if (firstIsVideo) {
              thumbs = body.find('.flex-control-thumbs li:nth-child(2) img').first();
            }

            thumbs.attr('src', data.images[0]);
            if (firstIsVideo) {
              if (e.target.classList.contains('first-child')) {
                body.find('.flex-control-thumbs li:nth-child(1) img').click();
              } else {
                thumbs.click();
              }
            }


            // Sticky-bar thumb.
            const stickyImg = body.find('.sticky-product-inner .product-thumbnail img');
            stickyImg.attr('src', data.images[0]).attr('srcset', '');
          }

          // Set product cart form
          if (typeof data.html !== 'undefined') {
            const productHtml = $(data.html);
            const formCart = $('form.cart, .is-on-backorder', productHtml);
            const backorderNotice = $('.is-on-backorder', productHtml);
            const stockNotice = $('.stock', productHtml);
            const cartFormWrap = $('.entry-summary .add-to-cart-form-wrapper');
            const stockWrap = $('.buy-area ul.checker-points');
            const currentForm = cartFormWrap.find('form.cart');
            const waitlist = $('.entry-summary .wcwl_elements');
            if (currentForm.length) {
              currentForm.replaceWith(formCart);
            } else {
              cartFormWrap.prepend(formCart);
            }
            // Remove stock notice and prepend new one if there is one.
            stockWrap.find('.stock').remove();
            if (stockNotice.length) {
              const stockSibling = document.querySelector('.buy-area ul.checker-points li.shipping');
              stockSibling.parentNode.insertBefore(stockNotice[0], stockSibling.nextSibling);
              stockWrap.prepend(stockNotice);
            }
            // Remove backorder notice and prepend new one if there is one.
            cartFormWrap.find('.is-on-backorder').remove();
            if (backorderNotice.length) {
              cartFormWrap.prepend(backorderNotice);
            }
            $('.maksimer-size-out-of-stock-notice').remove();
            if (formCart.length === 0) {
              // Set product out of stock notice.
              if (typeof data.outofstock !== 'undefined') {
                cartFormWrap.prepend(data.outofstock);
              }
            }
            // If full size product has waitlist.
            if (waitlist.length) {
              if (btn.first().hasClass('active')) {
                waitlist.removeClass('hidden');
                $('.maksimer-size-out-of-stock-notice').remove();
              } else {
                waitlist.addClass('hidden');
              }
            }


            // Check if subscriptionProductOptions variable is present and add its html to the cart form.
            const WCSubscriptionOptions = document.querySelector('.cart .wcsatt-options-wrapper .wcsatt-options-product');
            if (WCSubscriptionOptions && typeof subscriptionProductOptions !== 'undefined') {
              const oneTimeOption = WCSubscriptionOptions.querySelector('.one-time-option');
              const oneTimeInput = oneTimeOption.querySelector('input');
              const firstSubscriptionRow = WCSubscriptionOptions.querySelector('.subscription-option');
              const firstSubscriptionInput = firstSubscriptionRow.querySelector('input');

              // Insert the subscription button
              firstSubscriptionRow.insertAdjacentHTML('beforebegin', subscriptionProductOptions.button);

              const subscriptionFaker = WCSubscriptionOptions.querySelector('.subscription-option-faker');
              const fakeCheckbox = subscriptionFaker.querySelector('.subscription-option-faker-checkbox');
              fakeCheckbox.addEventListener('change', () => {
                if (fakeCheckbox.checked) {
                  firstSubscriptionInput.checked = true;

                  const priceWrapper = document.querySelector('.product .entry-summary .price');
                  const newPriceWrapper = subscriptionFaker.querySelector('.subscription-option-faker-details');
                  const newPrice = findPrice(newPriceWrapper);
                  updatePrice(priceWrapper, newPrice);

                  document.body.classList.add('have-chosen-subscription-option');
                } else {
                  fakeCheckbox.checked = true;
                }
              });

              // When a user click's on "one time delivery", remove the checked from the faker checkbox
              oneTimeInput.addEventListener('change', () => {
                if (oneTimeInput.checked) {
                  const priceWrapper = document.querySelector('.product .entry-summary .price');
                  const newPriceWrapper = oneTimeOption.querySelector('.one-time-option-details');
                  const newPrice = findPrice(newPriceWrapper);
                  updatePrice(priceWrapper, newPrice);

                  fakeCheckbox.checked = false;
                  document.body.classList.remove('have-chosen-subscription-option');
                }
              });
            }
          }

          // Disable active button from being clicked again, remove loading spinner
          setTimeout(() => {
            btn.parent().removeClass('maksimer-size-options-disabled');
            btn.removeClass('maksimer-size-option-loading');
            btn.prop('disabled', false);
            body.find('.maksimer-size-option.active').prop('disabled', true);
            body.removeClass('maksimer-size-options-loading');
          }, 500);

          calculateBeautyPoints();
        });

        // Re-call of certain functions after product size ajax is complete.
        $(document).ajaxComplete(() => {
          sizesAddToCart(body, btn);
        });
      });

      sizesAddToCart(body, btn);
    }
  }
});
